import { render, staticRenderFns } from "./UserPageAuthorized.vue?vue&type=template&id=17203a82&scoped=true&"
import script from "./UserPageAuthorized.vue?vue&type=script&lang=js&"
export * from "./UserPageAuthorized.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17203a82",
  null
  
)

export default component.exports